import React from "react";
import PropTypes from "prop-types";
import { useTrackElement, useTracking, useTranslation } from "@edreamsodigeo/frontend-core";
import { Body } from "@edreamsodigeo/prisma-design-system";
import { useDevice } from "../../clientSide/hooks/useDevice";
import { DividerWithContent } from "../common/components";
import { FORM_SWITCHER } from "./config/datameshIds";
import FormSwitcherButton from "./FormSwitcherButton";
import FormSwitcherLink from "./FormSwitcherLink";
const FormSwitcher = ({
  onClick,
  isFindBooking
}) => {
  const {
    t
  } = useTranslation();
  const {
    isDesktop
  } = useDevice();
  const {
    trackEvent: trackGAEvent
  } = useTracking();
  const label = isFindBooking ? t("mytripslogin.managebookings.footer.loginwithpassword") : t("mytripslogin.managebookings.footer.findbybooking");
  const trackingId = isFindBooking ? FORM_SWITCHER.LOGIN : FORM_SWITCHER.FIND_BY_BOOKING_REFERENCE;
  const clickTrackingRef = useTrackElement(["click"], trackingId);
  const trackEventBookingAuth = () => {
    const label = isFindBooking ? "go-to-login" : "find-booking_start";
    const action = isFindBooking ? "login-module-booking" : "login-module";
    trackGAEvent({
      category: "my_trips",
      action,
      label
    });
  };
  const onClickHandler = () => {
    trackEventBookingAuth();
    onClick();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DividerWithContent, {
    color: "neutral.40"
  }, /*#__PURE__*/React.createElement(Body, {
    type: "base",
    color: "neutral.80"
  }, t("mytripslogin.managebookings.footer.ordivider"))), isDesktop || !isFindBooking ? /*#__PURE__*/React.createElement(FormSwitcherLink, {
    label: label,
    onClick: onClickHandler,
    ref: clickTrackingRef
  }) : /*#__PURE__*/React.createElement(FormSwitcherButton, {
    label: label,
    onClick: onClickHandler,
    ref: clickTrackingRef
  }));
};
FormSwitcher.propTypes = {
  onClick: PropTypes.func.isRequired,
  isFindBooking: PropTypes.bool.isRequired
};
export default FormSwitcher;